import type {
  RevenueIntelligenceChatChartSpec,
  RevenueIntelligenceChatDataset,
} from "./RevenueIntelligenceChatContext";

type ChartLanguage = "en" | "sv";

export function getRevenueIntelligenceScatterEncodingLabels(
  chart: RevenueIntelligenceChatChartSpec,
  dataset: RevenueIntelligenceChatDataset,
  language: ChartLanguage = "en",
  getLabel: (field: string) => string = field => (
    [...dataset.dimensions, ...dataset.measures]
      .find(item => item.field === field)?.label ?? field
  ),
) {
  if (chart.type !== "scatter") return [];
  const bubbleSizeField = chart.yFields[1];
  return [
    `${language === "sv" ? "Horisontellt" : "Horizontal"}: ${getLabel(chart.xField)}`,
    `${language === "sv" ? "Vertikalt" : "Vertical"}: ${getLabel(chart.yFields[0])}`,
    ...(bubbleSizeField
      ? [`${language === "sv" ? "Bubbelstorlek" : "Bubble size"}: ${getLabel(bubbleSizeField)}`]
      : []),
  ];
}
